
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import HeaderThree from "../components/HeaderThree";
import InstructorOne from "../components/InstructorOne";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";

const AboutPage = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderOne */}
      <HeaderThree />

      {/* Breadcrumb */}
      <Breadcrumb title={"About Us"} />


      {/* InstructorOne */}
      <InstructorOne />


      {/* FooterOne */}
      <FooterOne />
    </>
  );
};

export default AboutPage;
